import { useState } from "react";
import { Link, NavLink } from "react-router-dom";

import Modal from "../Modal";
import { Button } from "../Elements";
import commonNetwork from "../../../common/api/commonNetwork";
import { toast } from "react-toastify";
import { getVPList } from "../../../store/slices/vpListSlice";
import { useDispatch } from "react-redux";
import { FormControlLabel, FormGroup, Switch } from "@mui/material";
import appHelpers from "../../../common/helpers/appHelpers";
import { getNavigationUrl } from "../../../common/helpers/navigationHelpers";


export default function VirtualPosCard({ data }) {

  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const isDemo = appHelpers.isDemoUser();
  const changeVPStatus = (status) => {
    setIsLoading(true);
    if (status === 'passive') {
      VPStatusUpdate(data.vpList.vpid, false);
    }
    else if (status === 'active') {
      VPStatusUpdate(data.vpList.vpid, true);
    }

  };
  const alertMessage = (status) => {
    if (status) {
      toast.success("Pos Aktif Edilmiştir.");
    }
    else {
      toast.success("Pos Pasif Edilmiştir.");
    }
  }

  const VPStatusUpdate = async (id, status) => {
    var params = {
      bankIdOrVpId: id,
      status: status
    }
    const res = await commonNetwork.post("/virtualpos/statuschange", params);
    if (res.isSuccess) {
      dispatch(getVPList());
      setOpenModal(false);
      setTimeout(() => {
        setIsLoading(false);
        alertMessage(res.isSuccess && status);
      }, 500)
    }
  }

  const handleClick = (e) => {
    e.preventDefault();
    window.open(
      data.bankpageurl,
      "_blank"
    );
  }

  return (
    <div
      className={`box hover:outline-2 hover:outline   hover:outline-contrast-30 shadow-md rounded-md bg-white`}
    >
      <div className="flex flex-col flex-nowrap items-start justify-between px-6 py-8 h-49 w-full">
        <div className="flex justify-between  w-full  mb-6">
          <div className="items-start">
            <img src={"/" + data.bankimgpath} alt="pos" className="bg-cover bg-center text-center  shadow-lg rounded-xl w-28 h-24 flex container flex-1" />
          </div>
          <div className="">
            <div className="">
              <h3 className=" text-right items-start   w-full  font-medium text-gray-400 ">
                {
                  data.vpList
                    ? data.vpList.vpdisplayname
                    : data.bankname
                }
              </h3>
            </div>
            <div className="">
              {data.vpList && data.status &&
                <FormGroup className="" >
                  <FormControlLabel
                    className={`flex flex-row justify-end font-small ${data.vpList.status == true ? "text-success-blue" : "text-gray-400"}`}
                    style={{
                      marginRight: 0,
                      marginLeft: 0,
                    }}
                    label={<p >{data?.vpList?.status == true ? "Aktif" : "Pasif"}</p>}
                    control={
                      <Switch
                        style={{
                          marginRight: 0,
                        }}
                        defaultChecked={data?.vpList?.status}
                        checked={data?.vpList?.status}
                        onChange={(e) => {
                          if (isDemo) {
                            toast.error("Demo kullanıcısında pos entegrasyonu yapamazsınız. Lütfen paket satın alınız.");
                          } else {
                            setOpenModal(true);
                          }
                        }}
                      />
                    }>
                  </FormControlLabel>
                </FormGroup>
              }

            </div>
          </div>
        </div>
        <div className="w-full flex flex-col">
          <div className={data.bankpageurl != "" && data.bankpageurl != null ? " flex flex-row justify-between items-center w-full  " : " flex flex-row justify-end items-center w-full  "}>
            {data.bankpageurl != "" && data.bankpageurl != null ?
              <div className="flex flex-row">
                <Link
                  className=""
                  data-menu-key="bankPageUrl"
                  onClick={handleClick}
                >
                  <span className="cursor-pointer text-center text-blue-700 text-[13px] font-medium  underline">Banka Paneline Git</span>
                </Link>
              </div> : null}
            <div className="flex flex-row space-x-2">
              {data.vpList && data.status !== "unwound" && (
                isDemo ? (
                  <Button size="xs" color="gray" hover="gray" callback={() => {
                    toast.error("Demo kullanıcısında pos entegrasyonu yapamazsınız. Lütfen paket satın alınız.");
                  }}
                  >
                    Düzenle
                  </Button>
                ) : (
                  <NavLink to={getNavigationUrl(data.vpid ? "/pos-baglanti-ayarlari/" + data.bankid + `?vpId=${data.vpId}` : "/pos-baglanti-ayarlari/" + data.bankid)} state={{ vpId: data.vpList ? data.vpList.vpid : 0, isDemo: data?.isDemo, isPf: data?.ispf, }} >
                    <Button size="xs" color="gray" hover="gray"
                    >
                      Düzenle
                    </Button>
                  </NavLink>
                )
              )}
              {data.vpList && data.status !== "unwound" && (
                isDemo ? (
                  <Button size="xs" color="primary" hover="primary" spanClass={"ml-3 mr-3"} callback={() => {
                    toast.error("Demo kullanıcısında pos entegrasyonu yapamazsınız. Lütfen paket satın alınız.");
                  }}
                  >
                    Ekle
                  </Button>
                ) : (
                  <NavLink to={getNavigationUrl(data.vpid ? "/pos-baglanti-ayarlari/" + data.bankid + `?vpId=${data.vpId}` : "/pos-baglanti-ayarlari/" + data.bankid)} state={{ vpId: 0, isDemo: data?.isDemo, isPf: data?.ispf }} >
                    <Button size="xs" color="primary" hover="primary" spanClass={"ml-3 mr-3"}
                    >
                      Ekle
                    </Button>
                  </NavLink>)
              )}
              {!data.vpList && data.status &&
                (
                  isDemo ? (
                    <Button size="xs" color="primary" hover="primary" callback={() => {
                      toast.error("Demo kullanıcısında pos entegrasyonu yapamazsınız. Lütfen paket satın alınız.");
                    }}
                    >
                      Bağlantı Kur
                    </Button>
                  ) : (
                    <NavLink to={getNavigationUrl(data.vpid ? "/pos-baglanti-ayarlari/" + data.bankid + `?vpId=${data.vpId}` : "/pos-baglanti-ayarlari/" + data.bankid)} state={{ vpId: data.vpList ? data.vpList.vpid : 0, isDemo: data?.isDemo, isPf: data?.ispf }} >
                      <Button size="xs" color="primary" hover="primary"
                      >
                        Bağlantı Kur
                      </Button>
                    </NavLink>
                  )
                )


              }
              <Modal openModal={openModal} setOpenModal={setOpenModal}>
                {
                  isLoading ? (
                    <div className="w-full shadow-md  text-warning-text">
                      <div className="m-4 p-4 bg-white flex flex-row justify-center items-center">
                        Kaydediliyor...
                      </div>
                    </div>
                  ) : (
                    <div>
                      <div className="sm:flex sm:items-start">
                        <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                          <h3 className="text-md leading-6 font-medium text-gray-900">
                            POS Bağlantısını
                            {data.vpList && data.vpList.status ? " Pasif" : " Aktif"} Et
                          </h3>
                          <div>
                            <div className="mt-4">

                              <img
                                className="text-error h-10 w-10 "
                                src={data.vpList && data.vpList.status ? "/icons/basarisiz.svg" : "/icons/basarili.svg"}
                                alt="error"
                              />
                            </div>
                          </div>
                          <div className="mt-4">
                            <p className="text-sm text-gray-500">
                              POS entegrasyonunuzu
                              {data.vpList && data.vpList.status > 0 ? " pasif" : " aktif"} hale
                              getirmek istediğinize emin misiniz?
                            </p>
                            <p className="text-sm text-gray-500">
                              {data.vpList && data.vpList.status > 0
                                ? " POS cihazınız kullanım dışı olacaktır."
                                : "  POS cihazınız kullanılmaya başlanacaktır. "}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="mt-5 mt-4 flex justify-end space-x-2">
                        <Button
                          color="gray"
                          hover="gray"
                          size="xs"
                          callback={() => {
                            setOpenModal(false);
                          }
                          }
                        >
                          İptal
                        </Button>
                        <Button
                          color="primary"
                          hover="primary"
                          size="xs"
                          callback={() => {
                            changeVPStatus(
                              data.vpList && data.vpList.status > 0 ? "passive" : "active"
                            );
                          }}
                        >
                          Kaydet
                        </Button>
                      </div>
                    </div>
                  )
                }

              </Modal>

            </div>
          </div>
        </div>
      </div>
    </div >

  );
}
